<template>
    <kt-panel>
        <div class="create-services">
            <router-link to="/online-factor-customer-format-create">
                <p class="btn btn-success">ایجاد قالب مشتری</p>
            </router-link>
            <router-link to="/factors" class="mr-2">
                <button class="btn btn-success">بازگشت</button>
            </router-link>
        </div>
        <div class="accordion accordion-toggle-arrow" id="userFilter">
            <div class="card online-factor-search-bar" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterForm"
                         aria-controls="filterForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                    <div class="card-body">
                        <form @submit.prevent="action($event, query)">
                            <kt-form-section>
                                <kt-form-row>
                                    <kt-col xs="12" sm="6" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="format_id">
                                                {{ $t('online-factor.hash_id')}}
                                            </kt-form-label>
                                            <kt-form-control
                                                ref="format_id"
                                                name="format_id"
                                                id="format_id"
                                                v-model="query.id"/>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="3">
                                      <kt-form-group>
                                        <kt-form-label for="format_name">
                                          {{ $t('online-factor.name')}}
                                        </kt-form-label>
                                        <kt-form-control
                                            ref="format_name"
                                            name="format_name"
                                            id="format_name"
                                            v-model="query.name"/>
                                      </kt-form-group>
                                    </kt-col>
                                </kt-form-row>
                            </kt-form-section>
                            <kt-form-section>
                                <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                            </kt-form-section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>


export default {
    props: {
        action: {
            default: function(e, query) {},
            required: true
        }
    },
    data() {
        return {
            query: {
            },

        }
    },
    methods: {

    },
     mounted(){
    }
}

</script>

<style scoped>
.create-services {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-end;
    }
</style>